import React from 'react';
import Modal from 'react-modal';
import { AiOutlineCloseCircle } from 'react-icons/ai';

Modal.setAppElement('#root');

export default function ModalPasajeros({ isOpen, onRequestClose, pasajeroDetails }) {

    const modalMarginStyle = window.innerWidth > 1280 ?
        { marginLeft: 'calc((100% - 20.5rem) / 3)', marginTop: '10rem' }
        : { margin: '0 auto', marginTop: '7.5rem' };

    return (
        <Modal
            className={`bg-gray-100 flex flex-col gap-4 rounded-2xl border-4 w-modal mx-auto border-orange-500 h-96 mb-10`}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={{
                overlay: {
                    backgroundColor: '#00000099',
                    overflow: 'auto',
                },
                content: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    ...modalMarginStyle,
                },
            }}
        >
            <div className="flex justify-end">
                <button className="p-1" onClick={onRequestClose}>
                    <AiOutlineCloseCircle className="text-orange-500 hover:bg-orange-600 hover:text-white rounded-full text-4xl" />
                </button>
            </div>
            {pasajeroDetails && (
                <div className='flex justify-around sm:mb-4 mt-6 '>
                    <div className='grid grid-cols-1 semi:grid-cols-5 grid-rows-6 mr-4'>
                        <div className='row-span-6  semi:col-span-2 flex justify-center mr-2 items-center'>
                            {pasajeroDetails.user_by_pk.photo ? (
                                <img
                                    src={pasajeroDetails.user_by_pk.photo}
                                    alt="Foto de perfil"
                                    style={{
                                        borderRadius: '50%',
                                        width: '250px',
                                        height: '250px',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <span>Imagen no disponible</span>
                            )}
                        </div>
                        <h2 className='semi:col-span-3 ml-2 text-xl font-bold'>Detalles del pasajero:</h2>
                        <p className='semi:col-span-3 ml-2'><span className='font-bold'>ID:</span> {pasajeroDetails.user_by_pk.user_id}</p>
                        <p className='semi:col-span-3 ml-2'>
                            <span className='font-bold'>Nombre:</span> {pasajeroDetails.user_by_pk.name ? pasajeroDetails.user_by_pk.name.toUpperCase() : 'N/A'}{' '}
                            {pasajeroDetails.user_by_pk.last_name ? pasajeroDetails.user_by_pk.last_name.toUpperCase() : 'N/A'}
                        </p>
                        <p className='semi:col-span-3 ml-2'><span className='font-bold'>Telefono:</span> {pasajeroDetails.user_by_pk.phone || 'N/A'}</p>
                        <p className='semi:col-span-3 ml-2'><span className='font-bold'>Email:</span> {pasajeroDetails.user_by_pk.email || 'N/A'}</p>
                        <p className='semi:col-span-3 ml-2'><span className='font-bold'>Estatus:</span> {pasajeroDetails.user_by_pk.status || 'N/A'}</p>
                    </div>
                </div>
            )}
        </Modal>
    );
}